import { render, staticRenderFns } from "./CompPeopleTourActivitiesCard.vue?vue&type=template&id=a40b77b0"
import script from "./CompPeopleTourActivitiesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourActivitiesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports